var scope_0 = require('C:/Users/Rishav/Documents/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/077850716cc014d3a44c23d33e8acb16.js').default;
var scope_1 = require('C:/Users/Rishav/Documents/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/36c5b51167f7ff6cf522e6bb5b1f6d42.js').default;
var scope_2 = require('C:/Users/Rishav/Documents/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/42cf58109040f3b138aed78b5c9e78a9.js').default;
var scope_3 = require('C:/Users/Rishav/Documents/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/513639ce845c45740203bdedf660df29.js').default;
var scope_4 = require('C:/Users/Rishav/Documents/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5b983701b44a32b65be1247f80da4429.js').default;
var scope_5 = require('C:/Users/Rishav/Documents/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5cf973814307256aa41ba2dbc9522cfa.js').default;
var scope_6 = require('C:/Users/Rishav/Documents/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/650fbe58154521ce5f41c18cabd8f5ad.js').default;
var scope_7 = require('C:/Users/Rishav/Documents/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/69fbad0964b11414459c655119a49721.js').default;
var scope_8 = require('C:/Users/Rishav/Documents/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7c36b204d67310ee7cd49aaf6e203704.js').default;
var scope_9 = require('C:/Users/Rishav/Documents/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/86ae6656153a085a66c400e5f283547f.js').default;
var scope_10 = require('C:/Users/Rishav/Documents/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/cfe67f17ed16642202a7d343ffc11bc7.js').default;
var scope_11 = require('C:/Users/Rishav/Documents/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d13e8b0d78ec5929131d9abb8d55335d.js').default;
var scope_12 = require('C:/Users/Rishav/Documents/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/df198556b87e62b2274618ed6cc4be5e.js').default;
var scope_13 = require('C:/Users/Rishav/Documents/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7,
scope_8,
scope_9,
scope_10,
scope_11,
scope_12,
scope_13 )
    